import React from 'react';

function WhatsappGreen({ ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.422 16.931 2 22.091l5.298-1.398a9.75 9.75 0 0 0 4.748 1.215c5.482 0 9.954-4.472 9.954-9.954 0-2.66-1.032-5.16-2.913-7.041A9.888 9.888 0 0 0 12.046 2c-5.482 0-9.954 4.472-9.954 9.954 0 1.766.458 3.463 1.33 4.977Zm5.459-9.725c.183 0 .39 0 .573.436.127.28.346.8.528 1.23.145.347.267.636.298.697.069.137.114.275.023.458l-.057.119c-.053.113-.091.195-.196.317-.05.058-.099.12-.147.179-.087.105-.17.207-.243.28-.137.138-.275.275-.114.527a7.73 7.73 0 0 0 1.422 1.79c.795.72 1.486 1.024 1.856 1.187.089.04.16.07.208.097.252.115.39.115.55-.069.161-.16.666-.757.826-1.009.16-.275.344-.23.574-.138.252.092 1.513.711 1.766.849.07.035.133.065.19.09.161.076.263.123.314.208.046.092.046.62-.16 1.216-.23.596-1.262 1.17-1.743 1.215-.044.004-.087.01-.13.015-.445.052-.984.115-2.967-.657-2.339-.923-3.907-3.186-4.31-3.768-.048-.069-.079-.114-.094-.131-.137-.16-1.055-1.399-1.055-2.66 0-1.198.579-1.818.843-2.1l.052-.056a.976.976 0 0 1 .688-.322h.505Z"
                fill="#4BAE4A"
            />
        </svg>
    );
}

export default WhatsappGreen;
